import React from 'react'
import styled from 'styled-components'

// icons
import { Barcode } from '@styled-icons/boxicons-regular/Barcode'
import { Team } from '@styled-icons/remix-fill'

// assets
import { Location } from 'components/Icons/Icons'

// utils
import th from 'utils/themeHelper'

// styles
import DashCardWrapper from './DashCardWrapper'

const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const Info = styled.div`
  display: block;
  margin: 10px 15px 0;
  flex: 1;
`

const InfoFieldLabel = styled.div`
  font-family: ${th('fonts.bold')};
  margin-right: 10px;
`

const InfoFieldValue = styled.div`
  font-family: ${th('fonts.regular')};
  margin-left: 30px;
`

const InfoFieldIcon = styled.div`
  margin-right: 10px;

  & > svg {
    height: 20px;
  }
`

const InfoGroup = styled.div`
  min-width: 30%;
`

const InfoGroupRow = styled.div`
  color: ${th('text.mid')};
  line-height: 1.25em;
  margin-bottom: 15px;
`

const InfoGroupRowInner = styled.div`
  display: flex;
  word-break: break-word;
`

const DashWorkspaceProjectCard = ({
  hasGodAdminRole,
  partners_count,
  workspace_name,
  workspace_project_code,
  workspace_project_name
}) => {
  return (
    <DashCardWrapper>
      <ActionsWrapper>
        <Info>
          <InfoGroup>
            {hasGodAdminRole && (
              <InfoGroupRow>
                <InfoGroupRowInner>
                  <InfoFieldIcon>
                    <Team />
                  </InfoFieldIcon>
                  <InfoFieldLabel>Workspace</InfoFieldLabel>
                </InfoGroupRowInner>

                <InfoGroupRowInner>
                  <InfoFieldValue>{workspace_name}</InfoFieldValue>
                </InfoGroupRowInner>
              </InfoGroupRow>
            )}

            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <Barcode />
                </InfoFieldIcon>
                <InfoFieldLabel>Project</InfoFieldLabel>
              </InfoGroupRowInner>

              <InfoGroupRowInner>
                <InfoFieldValue>{workspace_project_code}</InfoFieldValue>
              </InfoGroupRowInner>

              <InfoGroupRowInner>
                <InfoFieldValue>
                  <i>{workspace_project_name}</i>
                </InfoFieldValue>
              </InfoGroupRowInner>
            </InfoGroupRow>

            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <Location />
                </InfoFieldIcon>
                <InfoFieldLabel>Partners</InfoFieldLabel>
              </InfoGroupRowInner>

              <InfoGroupRowInner>
                <InfoFieldValue>{partners_count}</InfoFieldValue>
              </InfoGroupRowInner>
            </InfoGroupRow>
          </InfoGroup>
        </Info>
      </ActionsWrapper>
    </DashCardWrapper>
  )
}

export default DashWorkspaceProjectCard
